import { HOST_ID } from '@/util/appid'

export abstract class ApiService {
  constructor(protected readonly appId: string = HOST_ID) {
    this.appId = appId
  }
}
